import { t, useTranslations } from "~/translations/utils";
import integrationIcon from "~/assets/icons/integration-icon.webp";
import shippingIcon from "~/assets/icons/shipping-icon.webp";
import marketplaceIcon from "~/assets/icons/marketplace-icon.webp";

export function Features() {
  useTranslations();
  return (
    <section className="section container">
      <div className="columns">
        <div className="column">
          <div className="card has-background-primary-85">
            <header className="card-header">
              <div className="card-header-title is-flex is-justify-content-center">
                <img
                  className="icon is-large mr-3"
                  src={integrationIcon}
                  alt="Integration"
                />
                <div className="is-uppercase">
                  {t("landing.features.feature1")}
                </div>
              </div>
            </header>
            <div className="card-content">
              <div className="content has-text-centered">
                {t("landing.features.feature1Description")}
              </div>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="mt-5 is-hidden-mobile"></div>
          <div className="card has-background-primary-85">
            <header className="card-header">
              <div className="card-header-title is-flex is-justify-content-center">
                <img
                  className="icon is-large mr-3"
                  src={shippingIcon}
                  alt="Shipping"
                />
                <div className="is-uppercase">
                  {t("landing.features.feature2")}
                </div>
              </div>
            </header>
            <div className="card-content">
              <div className="content has-text-centered">
                {t("landing.features.feature2Description")}
              </div>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card has-background-primary-85">
            <header className="card-header">
              <div className="card-header-title is-flex is-justify-content-center">
                <img
                  className="icon is-large mr-3"
                  src={marketplaceIcon}
                  alt="Marketplace"
                />
                <div className="is-uppercase">
                  {t("landing.features.feature3")}
                </div>
              </div>
            </header>
            <div className="card-content">
              <div className="content has-text-centered">
                {t("landing.features.feature3Description")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
